// extracted by mini-css-extract-plugin
export default {"logo_wrapper":"styles_logo_wrapper__ZwbTv","logo_custom_wrapper":"styles_logo_custom_wrapper__QRAGP"};